import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NbDialogRef} from '@nebular/theme';
import {CommonService} from '../../../../../shared/services/common.service';
import {FormService} from '../../../../../shared/services/form.service';
import {TaskTypeService} from '../../../../../shared/services/task-type.service';
import {TaskTypeCategory} from '../../../../../shared/models/response/task-type-category';
import { ComponentPermission } from '../../../../../component.permission';

@Component({
  selector: 'ngx-task-type-create',
  templateUrl: './task-type-create.component.html',
  styleUrls: ['./task-type-create.component.scss'],
})
export class TaskTypeCreateComponent implements OnInit {

  ComponentPermission = ComponentPermission;
  form: FormGroup;
  isSubmitted = false;
  categories: TaskTypeCategory[];

  constructor(protected ref: NbDialogRef<TaskTypeCreateComponent>,
              private taskTypeService: TaskTypeService,
              private commonService: CommonService,
              private formService: FormService) {
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', [
        Validators.required,
      ]),
      description: new FormControl(''),
      color: new FormControl(''),
      taskTypeCategoryId: new FormControl(),
    });
  }

  submit() {
    const form = this.form.value;
    this.formService.extractErrorMessage(this.form);
    if (this.form.invalid) {
      this.isSubmitted = true;
      return;
    }
    this.taskTypeService.create(form).subscribe(
      result => {
        this.commonService.info('Created success.');
        this.ref.close(result);
      },
      error => {
        this.commonService.warningHtml(error.message);
      },
    );
  }

  cancel() {
    this.ref.close();
  }

  showError(name: string): string {
    return this.form.controls[name]
    && this.form.controls[name].errors
    && (this.form.controls[name].dirty
      || this.form.controls[name].touched
      || this.isSubmitted) ? 'has-error' : '';
  }

  colorChange(colorValue: string) {
    this.form.controls.color.setValue(colorValue);
  }

}
